import { useState } from "react";
import TimelineView from "./TimelineView";
import { trellisPalette } from "./palettes";
import compareBrands from "utils/compareBrands";
import FilterBar from "./FilterBar";
import { VStack } from "../../../../styled-system/jsx";
import { ButtonGroup } from "../../core/basic/ButtonGroup";
import { css } from "../../../../styled-system/css";
import { Switch } from "../../fields/base/Switch";
import PieChart from "../../core/blocks/PieChart";
import { formatPercent } from "../../../utils/formatNumber";

const MAX_BRANDS = 6;

const ShareView = ({
  shelfStatsData,
  homeBrand,
  selectedShelf,
  shelfData,
  selectedSearchId,
  filterSearchId,
  selectedRollupType,
  filterRollupType,
  setSelectedDateRange,
  dateRange,
  isLoading,
  shelfStatsTotalData,
}) => {
  const [showTimelineView, setShowTimelineView] = useState(false);
  const [share, setShare] = useState("total");

  // Ensure that chart data is broken into 10 categories for display - combine overflow with lowest values into 'Other' share
  const reduceShareOverflow = (data, max = 10) => {
    let otherBrandData = data.splice(max - 1);

    if (otherBrandData.find((data) => compareBrands(data.name, homeBrand))) {
      const homeBrandData = otherBrandData.find((data) => compareBrands(data.name, homeBrand));

      // Swap homebrand for lowest value in top 9 shareholders to ensure home brand is always visible in chart
      otherBrandData.push(data.pop());
      otherBrandData = otherBrandData.filter((otherBrand) => compareBrands(otherBrand.name, homeBrand) === false);
      data.push(homeBrandData);
    }

    const otherBrandShare = otherBrandData.reduce(
      (otherShare, brand) => otherShare + Number.parseFloat(brand.value),
      0,
    );

    data.push({ value: otherBrandShare, name: "Other" });

    return data;
  };
  const processShareViewData = () => {
    const tempData = shelfStatsTotalData;

    const key = {
      total: "share_of_shelf",
      organic: "org_share_of_shelf",
      sponsored: "share_of_voice",
    }[share];

    // Retrieve share of shelf and brand name from dataset
    let sosData = tempData.map((brandData) => ({
      value: brandData[key],
      name: brandData.brand,
    }));

    // Remove all data not needed for chart display, sort
    sosData = sosData.filter((element) => element.value > 0);
    sosData = sosData.sort((a, b) => {
      return b.value - a.value;
    });

    // Reduce to max brands, group overflow into 10th element
    if (sosData.length > MAX_BRANDS) {
      sosData = reduceShareOverflow(sosData, MAX_BRANDS);
    }

    return sosData;
  };
  const shareData = processShareViewData();

  return (
    <VStack gap="medium" alignItems="stretch">
      <FilterBar
        shelfData={shelfData}
        filterSearchId={filterSearchId}
        selectedShelf={selectedShelf}
        selectedSearchId={selectedSearchId}
        selectedRollupType={selectedRollupType}
        filterRollupType={filterRollupType}
        setSelectedDateRange={setSelectedDateRange}
        dateRange={dateRange}
        isLoading={isLoading}
      />
      <ButtonGroup
        buttons={[
          {
            value: "total",
            label: "Share of Shelf",
          },
          {
            value: "organic",
            label: "Share of Shelf (Organic)",
          },
          {
            value: "sponsored",
            label: "Share of Voice (Sponsored)",
          },
        ]}
        value={share}
        onSelect={setShare}
        className={css({
          alignSelf: "center",
        })}
      />

      {!showTimelineView ?
        <PieChart
          data={shareData}
          accessor={(v) => v.value}
          nameAccessor={(v) => v.name}
          formatter={(v) => formatPercent(v / 100, 2)}
          colors={trellisPalette}
          height={530}
        />
      : <TimelineView
          homeBrand={homeBrand}
          timelineData={shelfStatsData}
          shelfStatsTotalData={shelfStatsTotalData}
          share={share}
        />
      }

      <Switch isSelected={showTimelineView} onChange={setShowTimelineView}>
        {showTimelineView ? "Show Share View" : "Show Timeline View"}
      </Switch>
    </VStack>
  );
};

export default ShareView;
